import React, { useState } from 'react';
import { BusinessCardPlaceHolder } from '../businessCard/businessCard';
import './exceedingAlert.scss';
import ReactDom from 'react-dom';
import { useNavigate } from 'react-router-dom';

const PortalModal = () => {
  return ReactDom.createPortal(
    <>
      <div className="BusinessCardPlaceHolderOverlayStyles">
        <div className="BusinessCardPlaceHolderModalStyles">
          <div className="header">사업장 갯수 초과</div>
          <div className="description">N개 까지 사업장 추가가 가능합니다.</div>
          <div className="description">추가 생성을 원하면 결제 플랜을 변경해주세요</div>
          <div className="buttonRow">
            <button className="cancelButton">취소</button>
            <button className="confirmButton">변경</button>
          </div>
        </div>
      </div>
    </>,
    document.getElementById('modalPortal')!,
  );
};

const ExceedingAlert = ({ onClick }: { onClick: () => void }) => {
  const [show, setShow] = useState(false);

  const navigate = useNavigate();

  return (
    <div onClick={onClick}>
      <BusinessCardPlaceHolder />
    </div>
  );
};

export default ExceedingAlert;
